import { Injectable } from '@angular/core';
import {
  BridgingInterestMethod,
  BridgingProductRate,
  BridgingProductType,
} from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class BridgingProductsHelper {
  public productTypeToString(type: number): string {
    if (type === BridgingProductType.SteppedFixed) {
      return 'Stepped Fixed';
    }
    return BridgingProductType[type];
  }

  public maxTermToString(maxTerm: number): string {
    return maxTerm === 1 ? '1 month' : `${maxTerm} months`;
  }

  public interestMethodsToString(interestMethods: number[]): string {
    return interestMethods.map(i => BridgingInterestMethod[i]).join(', ');
  }

  public exitFeeToString(exitFee: boolean): string {
    return exitFee ? 'Yes' : 'No';
  }

  public monthlyRateToString(rates: BridgingProductRate[]) {
    if (!rates || rates.length < 1) {
      return '';
    }

    return `${rates[0].rate}%`;
  }

  public productTypesDiscreteFilter() {
    return Object.keys(BridgingProductType)
      .filter(k => !isNaN(Number(k)))
      .map(type => {
        const numericType = Number(type);
        return {
          label: BridgingProductType[numericType],
          value: numericType,
          icon: 'fa-file-contract',
        };
      });
  }
}
